import { createReducer } from 'redux-starter-kit';
import {
  fetchUserInfo,
  fetchUserSuccess,
  fetchUserFailure,
  fetchPaymentInfoSuccess,
  fetchPaymentInfoFailure,
  fetchMyPurchases,
  fetchMyPurchasesSuccess,
  fetchMyPurchasesFailure,
  setBundleType
} from 'actions/user';
import { logout } from 'actions/auth';

export default createReducer(
  {
    isFetching: false,
    paymentInfo: null,
    marketBundles: null,
    bundleType: null
  },
  {
    [fetchUserInfo]: (state, action) => ({
      ...state,
      isFetching: true
    }),
    [fetchUserSuccess]: (state, action) => {
      const { id, name, email, products } = action.payload;
      return {
        ...state,
        id,
        name,
        email,
        products,
        isFetching: false
      };
    },
    [fetchUserFailure]: (state, action) => ({
      ...state,
      isFetching: false
    }),

    [fetchPaymentInfoSuccess]: (state, action) => ({
      ...state,
      paymentInfo: action.payload
    }),
    [fetchPaymentInfoFailure]: (state, action) => ({
      ...state,
      paymentInfo: null
    }),

    [fetchMyPurchases]: (state, action) => ({
      ...state,
      marketBundles: [],
      isFetching: true
    }),
    [fetchMyPurchasesSuccess]: (state, action) => ({
      ...state,
      marketBundles: action.payload,
      isFetching: false
    }),
    [fetchMyPurchasesFailure]: (state, action) => ({
      ...state,
      marketBundles: [],
      isFetching: false
    }),
    [setBundleType]: (state, action) => ({
      ...state,
      bundleType: action.payload
    }),

    [logout]: (state, action) => ({
      ...state,
      paymentInfo: null
    })
  }
);
